<template>
  <div element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="loading">
    <div v-if="studentId === ''">
      <el-select key="term1" v-model="value" placeholder="请选择">
        <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id"> </el-option>
      </el-select>
      <el-tabs v-model="activeName" style="margin-top: 16px">
        <el-tab-pane label="年级统计" name="first">
          <el-table key="gradeTable" :data="gradeTable" stripe border style="width: 100%; margin-top: 15px">
            <el-table-column type="index" label="序号" align="center"> </el-table-column>
            <el-table-column prop="gradeName" label="年级" align="center"> </el-table-column>
            <el-table-column label="参与阅读人数/学生人数" align="center">
              <template slot-scope="scope"> {{ scope.row.joinStudentNumber }}/{{ scope.row.studentNumber }} </template>
            </el-table-column>
            <el-table-column label="参与阅读人数/教师人数" align="center">
              <template slot-scope="scope"> {{ scope.row.publishTeacherNumber }}/{{ scope.row.teacherNumber }} </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                <div>必读任务</div>
                <div>完成度/读后感数</div>
              </template>
              <template slot-scope="scope"> {{ scope.row.mustTaskScale }}%/{{ scope.row.mustTaskFellNumber }} </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                <div>推荐任务</div>
                <div>完成度/读后感数</div>
              </template>
              <template slot-scope="scope"> {{ scope.row.sellTaskScale }}%/{{ scope.row.sellTaskFellNumber }} </template>
            </el-table-column>
            <el-table-column prop="activityDuration" align="center">
              <template slot="header">
                <div>必读任务进度(人次)</div>
                <div>已读/在读/未开始</div>
              </template>
              <template slot-scope="scope"> {{ scope.row.mustTaskCompletedNumber }}/{{ scope.row.mustTaskReadingNumber }}/{{ scope.row.mustTaskNoNumber }} </template>
            </el-table-column>
            <el-table-column prop="activityDuration" align="center">
              <template slot="header">
                <div>推荐任务进度(人次)</div>
                <div>已读/在读/未开始</div>
              </template>
              <template slot-scope="scope"> {{ scope.row.sellTaskCompletedNumber }}/{{ scope.row.sellTaskReadingNumber }}/{{ scope.row.sellTaskNoNumber }} </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="toClass(scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="班级统计" name="second">
          <div>
            <span>选择年级：</span>
            <el-select v-model="gradeId" placeholder="请选择年级">
              <el-option v-for="item in gradeList" :key="item.gradeId" :label="item.name" :value="item.gradeId"> </el-option>
            </el-select>
          </div>
          <el-table key="classTable" :data="classTable" stripe border style="width: 100%; margin-top: 15px">
            <el-table-column type="index" label="序号" align="center"> </el-table-column>
            <el-table-column prop="className" label="班级" align="center"> </el-table-column>
            <el-table-column label="参与阅读人数/学生人数" align="center">
              <template slot-scope="scope"> {{ scope.row.joinStudentNumber }}/{{ scope.row.studentNumber }} </template>
            </el-table-column>
            <el-table-column label="参与阅读人数/教师人数" align="center">
              <template slot-scope="scope"> {{ scope.row.publishTeacherNumber }}/{{ scope.row.teacherNumber }} </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                <div>必读任务</div>
                <div>完成度/读后感数</div>
              </template>
              <template slot-scope="scope"> {{ scope.row.mustTaskScale }}%/{{ scope.row.mustTaskFellNumber }} </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                <div>推荐任务</div>
                <div>完成度/读后感数</div>
              </template>
              <template slot-scope="scope"> {{ scope.row.sellTaskScale }}%/{{ scope.row.sellTaskFellNumber }} </template>
            </el-table-column>
            <el-table-column prop="activityDuration" align="center">
              <template slot="header">
                <div>必读任务进度(人次)</div>
                <div>已读/在读/未开始</div>
              </template>
              <template slot-scope="scope"> {{ scope.row.mustTaskCompletedNumber }}/{{ scope.row.mustTaskReadingNumber }}/{{ scope.row.mustTaskNoNumber }} </template>
            </el-table-column>
            <el-table-column prop="activityDuration" align="center">
              <template slot="header">
                <div>推荐任务进度(人次)</div>
                <div>已读/在读/未开始</div>
              </template>
              <template slot-scope="scope"> {{ scope.row.sellTaskCompletedNumber }}/{{ scope.row.sellTaskReadingNumber }}/{{ scope.row.sellTaskNoNumber }} </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="toStudent(scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="学生统计" name="third">
          <div>
            <span>选择年级：</span>
            <el-select v-model="gradeId" placeholder="请选择年级" style="width: 160px; margin-right: 10px">
              <el-option v-for="item in gradeList" :key="item.gradeId" :label="item.name" :value="item.gradeId"> </el-option>
            </el-select>
            <span>选择班级：</span>
            <el-select v-model="classId" placeholder="请选择班级" style="width: 160px">
              <el-option v-for="item in classList" :key="item.id" :label="item.title" :value="item.id"> </el-option>
            </el-select>
          </div>
          <el-table key="studentTable" :data="studentTable" stripe border style="width: 100%; margin-top: 15px">
            <el-table-column type="index" label="序号" align="center"> </el-table-column>
            <el-table-column prop="studentName" label="学生姓名" align="center"> </el-table-column>
            <el-table-column label="年级班级" align="center">
              <template slot-scope="scope"> {{ scope.row.gradeName }}{{ scope.row.className }} </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                <div>必读任务</div>
                <div>完成度/读后感数</div>
              </template>
              <template slot-scope="scope"> {{ scope.row.mustTaskScale }}%/{{ scope.row.mustTaskFellNumber }} </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot="header">
                <div>推荐任务</div>
                <div>完成度/读后感数</div>
              </template>
              <template slot-scope="scope"> {{ scope.row.sellTaskScale }}%/{{ scope.row.sellTaskFellNumber }} </template>
            </el-table-column>
            <el-table-column prop="activityDuration" align="center">
              <template slot="header">
                <div>必读任务进度(人次)</div>
                <div>已读/在读/未开始</div>
              </template>
              <template slot-scope="scope"> {{ scope.row.mustTaskCompletedNumber }}/{{ scope.row.mustTaskReadingNumber }}/{{ scope.row.mustTaskNoNumber }} </template>
            </el-table-column>
            <el-table-column prop="activityDuration" align="center">
              <template slot="header">
                <div>推荐任务进度(人次)</div>
                <div>已读/在读/未开始</div>
              </template>
              <template slot-scope="scope"> {{ scope.row.sellTaskCompletedNumber }}/{{ scope.row.sellTaskReadingNumber }}/{{ scope.row.sellTaskNoNumber }} </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="studentDetail(scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-else>
      <el-page-header style="margin-bottom: 20px" @back="goBack"></el-page-header>
      <div>
        <span style="font-size: 16px; font-weight: 600; margin-right: 10px">{{ detailData.studentName }}</span
        ><span>{{ detailData.gradeName }}{{ detailData.className }}</span>
      </div>
      <div style="margin: 10px 0">
        <span>选择学期：</span>
        <el-select key="term2" v-model="value1" placeholder="请选择">
          <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id"> </el-option>
        </el-select>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="detailChartBox">
            <div style="flex: 1; height: 100%">
              <div class="chartBoxText" style="margin-bottom: 15px">必读任务：完成度{{ detailData.mustTaskScale }}%</div>
              <div class="chartBoxText">已读：{{ detailData.mustTaskCompletedNumber }}本</div>
              <div class="chartBoxText">在读：{{ detailData.mustTaskReadingNumber }}本</div>
              <div class="chartBoxText">未开始：{{ detailData.mustTaskNoNumber }}本</div>
            </div>
            <div style="flex: 1; height: 100%">
              <div id="mustChart" style="width: 100%; height: 100%"></div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="detailChartBox">
            <div style="flex: 1; height: 100%">
              <div class="chartBoxText" style="margin-bottom: 15px">推荐任务：完成度{{ detailData.sellTaskScale }}%</div>
              <div class="chartBoxText">已读：{{ detailData.sellTaskCompletedNumber }}本</div>
              <div class="chartBoxText">在读：{{ detailData.sellTaskReadingNumber }}本</div>
              <div class="chartBoxText">未开始：{{ detailData.sellTaskNoNumber }}本</div>
            </div>
            <div style="flex: 1; height: 100%">
              <div id="sellChart" style="width: 100%; height: 100%"></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div style="margin: 10px 0">
        <span>类型：</span>
        <el-select v-model="taskType" placeholder="请选择类型" clearable style="width: 120px; margin-right: 10px">
          <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.code"> </el-option>
        </el-select>
        <span>状态：</span>
        <el-select v-model="readStatus" placeholder="请选择状态" clearable style="width: 120px">
          <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.code"> </el-option>
        </el-select>
      </div>
      <el-table key="detailDataTable" :data="detailDataTable" stripe border style="width: 100%; margin-top: 15px">
        <el-table-column type="index" label="序号" align="center"> </el-table-column>
        <el-table-column prop="bookName" label="书名" align="center"> </el-table-column>
        <el-table-column label="分类" align="center">
          <template slot-scope="scope">
            <div>
              <span v-for="(item, index) in scope.row.readClassifyBookList" :key="item.id">{{ item.classifyName }}{{ index == scope.row.readClassifyBookList.length - 1 ? '' : '、' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">
            {{ getNameById(scope.row.taskType, typeList, 'code', 'name') }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ getNameById(scope.row.readStatus, statusList, 'code', 'name') }}
          </template>
        </el-table-column>
        <el-table-column label="读后感" align="center">
          <template slot-scope="scope">
            {{ scope.row.readFeelNumber > 0 ? '已上传' : '未上传' }}
          </template>
        </el-table-column>
        <el-table-column label="测评" align="center">
          <template slot-scope="scope">
            {{ scope.row.readPaperNumber > 0 ? (scope.row.isPass == 1 ? '已通过测评' : '未通过测评') : '未测评' }}
          </template>
        </el-table-column>
        <el-table-column prop="readStartTime" label="阅读开始时间" align="center"> </el-table-column>
        <el-table-column prop="readEndTime" label="阅读完成时间" align="center"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  dictcode,
  yearhistorylist,
  readStatisticsGradeCount,
  readStatisticsClassCount,
  readStatisticsStudentCount,
  readStatisticsStudentDetail,
  readStatisticsStudentDetailList,
  gradegradelist
} from '@/api/home'
export default {
  data() {
    return {
      studentId: '',
      activeName: 'first',
      options: [],
      value: '',
      value1: '',
      gradeList: [],
      classList: [],
      gradeId: '',
      classId: '',
      loading: false,
      schoolId: '',
      gradeTable: [],
      classTable: [],
      studentTable: [],
      detailData: {},
      init: true,
      page: 1,
      taskType: '',
      readStatus: '',
      typeList: [],
      statusList: [],
      detailDataTable: [],
      detailDataTotal: 0
    }
  },
  watch: {
    value(v) {
      this.value1 = v
      this.readStatisticsGradeCount()
      if (this.init) return
      this.readStatisticsClassCount()
      this.readStatisticsStudentCount()
    },
    gradeId(v) {
      if (this.init) return
      let index = this.gradeList.findIndex((item) => {
        return item.gradeId == v
      })
      this.classList = this.gradeList[index].classesList
      this.classId = this.classList[0].id
      this.readStatisticsClassCount()
    },
    classId(v) {
      if (this.init) return
      this.readStatisticsStudentCount()
    },
    value1() {
      if (this.studentId != '') {
        this.readStatisticsStudentDetail()
        this.readStatisticsStudentDetailList()
      }
    },
    taskType() {
      this.readStatisticsStudentDetailList()
    },
    readStatus() {
      this.readStatisticsStudentDetailList()
    }
  },
  methods: {
    getNameById(id, targetList, idName, name) {
      let result = ''
      let index = targetList.findIndex((i) => {
        return i[idName] == id
      })
      if (index != -1) {
        result = targetList[index][name]
      }
      return result
    },
    goBack() {
      this.studentId = ''
    },
    studentDetail(item) {
      this.studentId = item.readStudentId
      this.readStatisticsStudentDetail()
      this.readStatisticsStudentDetailList()
    },
    readStatisticsStudentDetailList() {
      let that = this
      that.loading = true
      let params = {
        termId: this.value1,
        readStudentId: this.studentId,
        pageNum: this.page,
        taskType: this.taskType,
        readStatus: this.readStatus
      }
      readStatisticsStudentDetailList(params)
        .then((res) => {
          that.loading = false
          that.detailDataTable = res.data.data.dataList
          that.detailDataTotal = res.data.data.totalCount
        })
        .catch(() => {
          that.loading = false
        })
    },
    readStatisticsStudentDetail() {
      let that = this
      that.loading = true
      let params = {
        termId: this.value1,
        readStudentId: this.studentId
      }
      readStatisticsStudentDetail(params)
        .then((res) => {
          that.loading = false
          that.detailData = res.data.data
          that.$nextTick(() => {
            that.mustChart()
            that.sellChart()
          })
        })
        .catch(() => {
          that.loading = false
        })
    },
    sellChart() {
      var chartDom = this.$echarts.getInstanceByDom(document.getElementById('sellChart')) //有的话就获取已有echarts实例的DOM节点。
      let data = [
        { value: this.detailData.sellTaskCompletedNumber, name: '已读' },
        { value: this.detailData.sellTaskReadingNumber, name: '在读' },
        { value: this.detailData.sellTaskNoNumber, name: '未开始' }
      ]
      var option = {
        legend: {
          show: false
        },
        devicePixelRatio: 1000,
        tooltip: {
          trigger: 'item',
          textStyle: {
            fontSize: 10 //此处设置提示文字大小
          }
        },
        series: [
          {
            name: '',
            label: {
              show: false
            },
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['65%', '80%'],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      if (chartDom == null) {
        this.$nextTick(() => {
          // 如果不存在，就进行初始化。
          chartDom = document.getElementById('sellChart')
          var myChart = this.$echarts.init(chartDom)
          option && myChart.setOption(option)
        })
      } else {
        this.$nextTick(() => {
          chartDom.setOption(option, true)
        })
      }
    },
    mustChart() {
      var chartDom = this.$echarts.getInstanceByDom(document.getElementById('mustChart')) //有的话就获取已有echarts实例的DOM节点。
      let data = [
        { value: this.detailData.mustTaskCompletedNumber, name: '已读' },
        { value: this.detailData.mustTaskReadingNumber, name: '在读' },
        { value: this.detailData.mustTaskNoNumber, name: '未开始' }
      ]
      var option = {
        legend: {
          show: false
        },
        devicePixelRatio: 1000,
        tooltip: {
          trigger: 'item',
          textStyle: {
            fontSize: 10 //此处设置提示文字大小
          }
        },
        series: [
          {
            name: '',
            label: {
              show: false
            },
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['65%', '80%'],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      if (chartDom == null) {
        this.$nextTick(() => {
          // 如果不存在，就进行初始化。
          chartDom = document.getElementById('mustChart')
          var myChart = this.$echarts.init(chartDom)
          option && myChart.setOption(option)
        })
      } else {
        this.$nextTick(() => {
          chartDom.setOption(option, true)
        })
      }
    },
    toClass(item) {
      this.gradeId = item.gradeId
      this.activeName = 'second'
    },
    toStudent(item) {
      this.classId = item.classId
      this.activeName = 'third'
    },
    readStatisticsGradeCount() {
      let that = this
      that.loading = true
      let params = {
        termId: this.value,
        schoolId: this.schoolId
      }
      readStatisticsGradeCount(params)
        .then((res) => {
          that.loading = false
          that.gradeTable = res.data.data
        })
        .catch(() => {
          that.loading = false
        })
    },
    readStatisticsClassCount() {
      let that = this
      that.loading = true
      let params = {
        termId: this.value,
        gradeId: this.gradeId,
        schoolId: this.schoolId
      }
      readStatisticsClassCount(params)
        .then((res) => {
          that.loading = false
          that.classTable = res.data.data
        })
        .catch(() => {
          that.loading = false
        })
    },
    readStatisticsStudentCount() {
      let that = this
      that.loading = true
      let params = {
        termId: this.value,
        classId: this.classId,
        schoolId: this.schoolId
      }
      readStatisticsStudentCount(params)
        .then((res) => {
          that.loading = false
          that.studentTable = res.data.data
        })
        .catch(() => {
          that.loading = false
        })
    },
    gradegradelist() {
      let that = this
      let params = {
        schoolId: that.schoolId
      }
      gradegradelist(params)
        .then((res) => {
          that.gradeList = res.data.data
          that.gradeId = res.data.data[0].gradeId
          that.classList = res.data.data[0].classesList
          that.classId = res.data.data[0].classesList[0].id
          that.readStatisticsClassCount()
          that.readStatisticsStudentCount()
          this.init = false
        })
        .catch(() => {
          that.loading = false
        })
    },
    list() {
      let that = this
      yearhistorylist()
        .then((res) => {
          that.options = res.data.data
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].isCurrent == 1) {
              that.value = res.data.data[i].id
              that.value1 = res.data.data[i].id
            }
          }
        })
        .catch(() => {
          that.loading = false
        })
    },
    dictcode() {
      let params = {
        code: 'read_task_type'
      }
      dictcode(params).then((res) => {
        this.typeList = res.data.data
      })
    },
    dictcode1() {
      let params = {
        code: 'read_status'
      }
      dictcode(params).then((res) => {
        this.statusList = res.data.data
      })
    }
  },
  mounted() {
    this.schoolId = JSON.parse(localStorage.getItem('leader')).orgId
    this.list()
    this.gradegradelist()
    this.dictcode()
    this.dictcode1()
  }
}
</script>

<style scoped>
.chartTitle {
  padding: 10px 20px;
  background: #f0f0f0;
  color: red;
  margin: 10px 0;
}
.detailChartBox {
  padding: 15px;
  height: 120px;
  background: #eaf1fb;
  display: flex;
}
.chartBoxText {
  font-size: 15px;
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/statistics/orgRead.vue